import React, { useRef, useState } from "react";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import * as Yup from "yup";



// components
import { ButtonCancel, ButtonSubmit, GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {
    FORM,
} from "../../../components/i18n/i18n";
import { TT_HISTORY } from "../../../components/i18n/toolTips";
import { FL_MAIN_DATA_BASE, FL_NAME} from "../../../components/i18n/formLabels";
import { PH_NAME} from "../../../components/i18n/placeHolders";

// actions
import { setLoading, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";

// services
import { fbProjectService } from "../../../jwt/_services/firebase/fbProjectService";

// providers
import {fbDatabaseProvider} from "../../../providers/fbDatabaseProvider";
import Switch from "react-bootstrap-switch";



const FbProjectForm = props => {
    const { editMode, disableInputs, domainObject } = props.formProps;

    const [showModal, setShowModal] = useState(true)
    const [fbDataBaseId, setFbDataBaseId] = useState(domainObject?.mainDb?.id || null);
    const [useRealtime, setUseRealtime] = useState(domainObject?.useRealtime || false)
    const [useFirestore, setUseFirestore] = useState(domainObject?.useFirestore || false)

    const modalRef = useRef(null);


    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({});

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            code: domainObject?.code,
            name: domainObject?.name,
            bucketName: domainObject?.bucketName,
            projectName: domainObject?.projectName,
            translateLocation: domainObject?.translateLocation,
            fileName: domainObject?.fileName,
            glossaryPath: domainObject?.glossaryPath,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data,
            useFirestore,
            useRealtime
        };

        if (fbDataBaseId !== null)
            dataRequest.mainDb = { id : fbDataBaseId }

        if (editMode) {
            let id = domainObject.id;
            dataRequest.id = id

            genericActions.update(fbProjectService, id, dataRequest)
        } else {
            genericActions.save(fbProjectService, dataRequest)
        }


        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }
    
    return (<>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>{FL_NAME}</Label>
                                <Input type="text"
                                       name="name"
                                       placeholder={PH_NAME}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ 'Service account key' }</Label>
                                <Input type="text"
                                       name="fileName"
                                       placeholder={PH_NAME}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ 'Espacio de almacenamiento' }</Label>
                                <Input type="text"
                                       name="bucketName"
                                       placeholder={PH_NAME}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ 'Nombre de proyecto (Firebase)' }</Label>
                                <Input type="text"
                                       name="projectName"
                                       placeholder={PH_NAME}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ 'Ubicación de translate' }</Label>
                                <Input type="text"
                                       name="translateLocation"
                                       placeholder={PH_NAME}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ FL_MAIN_DATA_BASE }</Label>
                                <SelectGeneric
                                    title={ FL_MAIN_DATA_BASE }
                                    initialValue={ fbDataBaseId }
                                    setExternalValue={ setFbDataBaseId }
                                    provider={ fbDatabaseProvider }
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{'¿Usa Realtime?'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={useRealtime}
                                    onChange={(item,val)=>setUseRealtime(val)}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>{'¿Usa Firestore?'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={useFirestore}
                                    onChange={(item,val)=>setUseFirestore(val)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label>{'Path del Glosario'}</Label>
                                <Input type="text"
                                       name="glossaryPath"
                                       placeholder={'Path del Glosario'}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                                {errors.glossaryPath && <span className="text-danger">{errors.glossaryPath.message}</span>}
                            </FormGroup>

                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(FbProjectForm)